export const FIRST = 'icofont-double-left';
export const LAST = 'icofont-double-right';
export const PREV = 'icofont-caret-left';
export const NEXT = 'icofont-caret-right';
